export default "__VITE_ASSET__Dzs06EQN__"